var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11,
    fill: "white",
    stroke: "#FE3E9A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.75354,
    y: 12.6147,
    width: 2,
    height: 6.85609,
    rx: 1,
    transform: "rotate(-50.406 4.75354 12.6147)",
    fill: "#FE3E9A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5618,
    y: 5.10986,
    width: 2,
    height: 13.3502,
    rx: 1,
    transform: "rotate(36.6565 16.5618 5.10986)",
    fill: "#FE3E9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.5aaae02a45d5c6c032fb66b4eaa8f4e4.svg";
export { ForwardRef as ReactComponent };